import React from 'react'
import MediaQuery from 'react-responsive'

import { Link } from 'react-router-dom'

import bannerViagem from '@loyal_images/banners/banner_iupp_viagem.png'
import bannerViagemMobile from '@loyal_images/banners/banner_iupp_viagem_mobile.png'

const ConexxeBanner = () => (
  <div className='bx-bannerConexxe pos-relative pb-2'>
    <div className='container px-0'>
      <div className='row mx-0'>
        <div className='col-12 px-1 px-sm-0 txt-center'>
          <Link to={process.env.REACT_APP_URL_VIAGEM || '/mileage'} title='Veja nossas viagens'>
            <MediaQuery maxDeviceWidth={475}>
              <img src={bannerViagemMobile} alt='Veja nossas viagens' className='w-100' />
            </MediaQuery>
            <MediaQuery minDeviceWidth={476}>
              <img src={bannerViagem} alt='Veja nossas viagens' className='w-100' />
            </MediaQuery>
          </Link>
        </div>
      </div>
    </div>
  </div>
)

export default ConexxeBanner



// WEBPACK FOOTER //
// ./src/features/Slider/ConexxeBanner.js